import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientDisabledModalComponent } from './patient-disabled-modal.component';
import { RegisterNewPatientModule } from '../../register-new-patient/register-new-patient.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [PatientDisabledModalComponent],
  imports: [
    CommonModule,
    RegisterNewPatientModule,
    PipesModule
  ],
  exports: [PatientDisabledModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PatientDisabledModalModule { }

